import React, { useState, useEffect } from 'react';
import { Spin, Alert, Tag, Button, Card, Row, Col, Input, message, Modal } from 'antd';
import { FormOutlined, CheckCircleOutlined, ClockCircleOutlined, LoginOutlined } from '@ant-design/icons';
import axios from 'axios';
import coaImg from '../../pages/assets/footer/coa.png';
import flagImg from '../../pages/assets/footer/flag.png';
import QoCCollectorForm from './QoCCollectorForm';

const API = window.location.hostname.includes('qoctesting') ? '/qoctesting/api/' : '/qoc/api/';

export default function QoCCollectorPortal({ match }) {
    const emailParam = match?.params?.email ? decodeURIComponent(match.params.email) : null;
    const [email,       setEmail]       = useState(emailParam || '');
    const [surveys,     setSurveys]     = useState([]);
    const [loading,     setLoading]     = useState(false);
    const [searched,    setSearched]    = useState(false);
    const [activeSurvey, setActiveSurvey] = useState(null);
    const [error,       setError]       = useState(null);

    useEffect(() => {
        if (emailParam) loadSurveys(emailParam);
    }, [emailParam]); // eslint-disable-line

    const loadSurveys = async (em) => {
        setLoading(true);
        setError(null);
        try {
            const r = await axios.get(API + 'survey/collector-portal/' + encodeURIComponent(em || email));
            if (r.data.code !== 200) throw new Error(r.data.message);
            setSurveys(r.data.data || []);
            setSearched(true);
        } catch(e) { setError(e.response?.data?.message || e.message); }
        finally { setLoading(false); }
    };

    if (activeSurvey) {
        return (
            <div>
                {/* Back button */}
                <div style={{background:'#0d2137',padding:'10px 20px'}}>
                    <Button onClick={()=>setActiveSurvey(null)} style={{color:'#fff',borderColor:'rgba(255,255,255,0.3)',background:'transparent'}}>
                        ← Back to My Surveys
                    </Button>
                </div>
                <QoCCollectorForm match={{params:{token: activeSurvey.access_token}}} />
            </div>
        );
    }

    return (
        <div style={{minHeight:'100vh',background:'#f0f4f8'}}>
            {/* Header */}
            <div style={{background:'linear-gradient(135deg,#0d2137,#1e3a5f,#1a4f7a)',boxShadow:'0 4px 20px rgba(0,0,0,0.3)'}}>
                <div style={{background:'rgba(0,0,0,0.2)',padding:'6px 24px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{fontSize:11,color:'rgba(255,255,255,0.7)',letterSpacing:1.5,textTransform:'uppercase'}}>Kingdom of Eswatini</div>
                    <img src={flagImg} alt="Flag" style={{height:20,borderRadius:2}}/>
                </div>
                <div style={{padding:'20px 40px',display:'flex',alignItems:'center',gap:20}}>
                    <img src={coaImg} alt="Coat of Arms" style={{height:70,filter:'drop-shadow(0 2px 8px rgba(0,0,0,0.4))',flexShrink:0}}/>
                    <div style={{flex:1,textAlign:'center'}}>
                        <div style={{fontSize:12,color:'rgba(255,255,255,0.7)',fontWeight:600,marginBottom:4}}>Ministry of Health</div>
                        <h1 style={{color:'#fff',margin:'0 0 4px',fontSize:20,fontWeight:800}}>Data Collector Portal</h1>
                        <div style={{color:'rgba(255,255,255,0.7)',fontSize:12}}>Access your assigned surveys</div>
                    </div>
                    <img src={coaImg} alt="" style={{height:70,opacity:0.5,flexShrink:0}}/>
                </div>
            </div>

            <div style={{maxWidth:700,margin:'0 auto',padding:'32px 16px'}}>
                {/* Email lookup */}
                {!searched && (
                    <Card style={{marginBottom:24,borderRadius:12,boxShadow:'0 2px 12px rgba(0,0,0,0.08)'}}>
                        <div style={{textAlign:'center',marginBottom:20}}>
                            <div style={{fontSize:40,marginBottom:8}}>📧</div>
                            <h2 style={{margin:0,color:'#0d2137'}}>Enter Your Email</h2>
                            <p style={{color:'#888',marginTop:4}}>Enter the email address where you received your survey invitation</p>
                        </div>
                        <div style={{display:'flex',gap:8,maxWidth:400,margin:'0 auto'}}>
                            <Input size="large" value={email} onChange={e=>setEmail(e.target.value)}
                                placeholder="your.email@example.com"
                                onPressEnter={()=>loadSurveys(email)}/>
                            <Button type="primary" size="large" icon={<LoginOutlined/>}
                                loading={loading} onClick={()=>loadSurveys(email)}>
                                Access
                            </Button>
                        </div>
                        {error && <Alert type="error" message={error} showIcon style={{marginTop:12}}/>}
                    </Card>
                )}

                {/* Survey list */}
                {searched && (
                    <div>
                        {/* Collector profile card */}
                        {surveys.length > 0 && (
                            <div style={{display:'flex',alignItems:'center',gap:16,padding:'16px 20px',
                                background:'#fff',borderRadius:12,marginBottom:16,
                                boxShadow:'0 2px 8px rgba(0,0,0,0.06)',borderLeft:'4px solid #1890ff'}}>
                                <div style={{width:48,height:48,borderRadius:24,background:'#1890ff',
                                    display:'flex',alignItems:'center',justifyContent:'center',
                                    fontSize:20,color:'#fff',fontWeight:700,flexShrink:0}}>
                                    {(surveys[0]?.collector_name||email||'?')[0].toUpperCase()}
                                </div>
                                <div style={{flex:1}}>
                                    <div style={{fontWeight:700,fontSize:16,color:'#0d2137'}}>
                                        {surveys[0]?.collector_name || email}
                                    </div>
                                    <div style={{fontSize:12,color:'#64748b'}}>{email}</div>
                                    <div style={{fontSize:12,color:'#64748b',marginTop:2}}>
                                        {surveys.length} survey{surveys.length!==1?'s':''} assigned · {surveys.reduce((t,s)=>t+(s.submitted_count||0),0)} total submissions
                                    </div>
                                </div>
                                <Button size="small" onClick={()=>{setSearched(false);setSurveys([]);}}>
                                    Change Email
                                </Button>
                            </div>
                        )}
                        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
                            <h2 style={{margin:0,color:'#0d2137'}}>Your Surveys ({surveys.length})</h2>
                        </div>

                        {surveys.length === 0 ? (
                            <Alert type="info" showIcon
                                message="No surveys found"
                                description={`No active surveys found for ${email}. Contact your supervisor if you expect to have surveys assigned.`}/>
                        ) : (
                            <Row gutter={[16,16]}>
                                {surveys.map(s => {
                                    const isSubmitted = s.my_submitted;
                                    const isDraft = s.my_draft;
                                    return (
                                        <Col key={s.id} xs={24} sm={12}>
                                            <Card hoverable size="small" style={{
                                                borderRadius:10,
                                                borderTop:`3px solid ${isSubmitted?'#16a34a':isDraft?'#d97706':'#1890ff'}`,
                                                boxShadow:'0 2px 8px rgba(0,0,0,0.06)'
                                            }}>
                                                <div style={{fontWeight:700,fontSize:15,marginBottom:4,color:'#0d2137'}}>{s.title}</div>
                                                {s.program_name && <Tag color="blue" style={{marginBottom:6}}>{s.program_name}</Tag>}
                                                <div style={{fontSize:12,color:'#888',marginBottom:10}}>
                                                    {s.category} · {s.question_count} questions
                                                    {s.period_end && <span> · Due: {s.period_end}</span>}
                                                </div>
                                                {s.submitted_count > 0 && (
                                                    <div style={{marginBottom:8}}>
                                                        <div style={{fontSize:11,color:'#888',marginBottom:4}}>
                                                            {s.submitted_count} facilit{s.submitted_count===1?'y':'ies'} collected
                                                            {s.total_facilities ? ` of ${s.total_facilities}` : ''}
                                                        </div>
                                                        <div style={{display:'flex',gap:4,flexWrap:'wrap'}}>
                                                            {(s.submissions||[]).filter(r=>r.status==='submitted').slice(0,3).map((r,i)=>(
                                                                <Tag key={i} color="green" style={{fontSize:10,margin:0}}>{r.facility_name?.split(' ')[0]}</Tag>
                                                            ))}
                                                            {s.submitted_count > 3 && <Tag style={{fontSize:10,margin:0}}>+{s.submitted_count-3} more</Tag>}
                                                        </div>
                                                    </div>
                                                )}
                                                <Button type="primary" block
                                                    icon={isDraft?<ClockCircleOutlined/>:<FormOutlined/>}
                                                    style={{background:s.submitted_count>0?'#059669':isDraft?'#d97706':'#1890ff',
                                                        borderColor:s.submitted_count>0?'#059669':isDraft?'#d97706':'#1890ff'}}
                                                    onClick={()=>setActiveSurvey(s)}>
                                                    {s.submitted_count>0 ? '+ Add Facility' : isDraft ? 'Continue Draft' : 'Start Survey'}
                                                </Button>
                                            </Card>
                                        </Col>
                                    );
                                })}
                            </Row>
                        )}
                    </div>
                )}

                <div style={{textAlign:'center',marginTop:32,fontSize:11,color:'#94a3b8'}}>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
                        <img src={coaImg} alt="" style={{height:24,opacity:0.4}}/>
                        Ministry of Health · Kingdom of Eswatini
                        <img src={flagImg} alt="" style={{height:12,opacity:0.4,borderRadius:2}}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
